var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-carousel',{attrs:{"interval":4000,"height":"400px"}},_vm._l((_vm.imgList),function(item){return _c('el-carousel-item',{key:item.id},[_c('router-link',{attrs:{"to":item.routerPath}},[_c('img',{staticClass:"image",attrs:{"src":item.src,"alt":""}})])],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }